export default __webpack_public_path__ + "static/media/ESIcon.804de1aa.svg";